import { Navigate, useNavigate } from "react-router-dom";
import { ResponsiveFlex, TextInput, Tooltip } from "@narmi/design_system";
import { ProgressButtons } from "cerulean";
import { modules } from "byzantine";
import { MAX_MEMO_LENGTH } from "byzantine/src/dbbl/businessLogic/modules/achPayments";
import { useLocalization } from "@fluent/react";
import * as formAdapters from "../../../src/adapters";
import HeaderWithSteps from "../../HeaderWithSteps";
import { useSudoContext } from "../../SudoContext";
import {
  ACH_PAYMENT_REVIEW_ROUTE,
  ACH_PAYMENT_DETAIL_ROUTE,
  ACH_PAYMENT_ROUTE,
} from "./ACHPaymentRoutes";
import { TransactionTypeSection } from "./PaymentScreen";
import styles from "./PaymentScreen.module.scss";

const AdditionalDetailsScreen = () => {
  const { l10n } = useLocalization();
  const navigate = useNavigate();
  const { establishSudo } = useSudoContext();
  const form = modules.achPayments.ACHPaymentForm.useForm();
  const codes = modules.achPayments.useSECCodes([
    form.values.transactionType,
  ]);
  const isDebitPayment = modules.achPayments.useIsDebitACHPayment();
  const isSingleExpediteEnabled =
    modules.achPayments.useIsSingleExpediteEnabled();
  const isInstantDeliverySelected =
    modules.achPayments.useIsInstantACHDelivery();
  const isInstantDelivery =
    isSingleExpediteEnabled && isInstantDeliverySelected;
  const isSingleExpediteAvailable =
    modules.achPayments.useIsSingleExpediteAvailable();
  const { onContinue } = modules.achPayments.useAdditionalDetails();
  const headerText = isDebitPayment
    ? l10n.getString("single-ach-payment-collect-title")
    : l10n.getString("single-ach-payment-send-title");

  // instant delivery skips this step
  if (isInstantDelivery) {
    return (
      <Navigate
        to={`/transfer/${ACH_PAYMENT_ROUTE}/${ACH_PAYMENT_REVIEW_ROUTE}`}
        replace
      />
    );
  }

  const handleClickNext = () => {
    const handleNext = () => {
      navigate(`/transfer/${ACH_PAYMENT_ROUTE}/${ACH_PAYMENT_REVIEW_ROUTE}`);
    };
    const handleTrySudo = () => {
      establishSudo(
        `/transfer/${ACH_PAYMENT_ROUTE}/${ACH_PAYMENT_REVIEW_ROUTE}`
      );
    };

    onContinue(handleNext, handleTrySudo);
  };

  return (
    <>
      <ResponsiveFlex gapSize="xl">
        <HeaderWithSteps
          headerText={headerText}
          icon={
            !isSingleExpediteAvailable ? (
              <Tooltip
                text={l10n.getString("ach-payment-payment-title-tooltip")}
              >
                <i className={`narmi-icon-info ${styles.headerInfoIcon}`} />
              </Tooltip>
            ) : undefined
          }
        />

        <TransactionTypeSection codes={codes} />

        <ResponsiveFlex gapSize="m">
          <h4 className="fontSize--m nds-sans">
            {l10n.getString("ach-payment-internal-details")}
          </h4>
          <TextInput
            label={l10n.getString("label-note-optional")}
            maxLength={MAX_MEMO_LENGTH}
            {...formAdapters.input(form, "memo")}
          />
        </ResponsiveFlex>

        <ProgressButtons
          backLabel={l10n.getString("button-back")}
          nextLabel={l10n.getString("button-next")}
          onBack={() =>
            navigate(
              `/transfer/${ACH_PAYMENT_ROUTE}/${ACH_PAYMENT_DETAIL_ROUTE}`
            )
          }
          onNext={handleClickNext}
        />
      </ResponsiveFlex>
    </>
  );
};

export default AdditionalDetailsScreen;
